import PropTypes from "prop-types";
import SGLogoIcon from "/public/images/icons/sgLogoIconNoFill.svg?react";
import SGLogoFull from "/public/images/icons/sgLogoNoFill.svg?react";

export default function Logo({ fill = "black", size = "full", className }) {

  if (size === "full") {
    return (
      <SGLogoFull
        style={{ fill: fill === "Bronze" ? '#AD8A56' : fill }}
        className={`w-[200.12px] h-[72.04px] ${className}`}
        data-testid="logo"
      />
    );
  } else if (size === "icon") {
    return (
      <SGLogoIcon style={{ fill: fill === "Bronze" ? '#AD8A56' : fill }} className="w-[72.03px] h-[72.04px]" data-testid="logo" />
    );
  }
}

Logo.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.oneOf(["full", "icon"]),
  className: PropTypes.string,
};
